import Context from './Context.js';
import Gateway from '../Gateway';

export default class PerformanceTiming extends Context {
  constructor() {
    super();
    this.data = Gateway.window.performance.timing
  };

  static get key() {
    return 'PerformanceTiming'
  }

  static get version() {
    return '1-0-0';
  }

  static get host() {
    return 'org.w3';
  }

  static get shouldBeAdded() {
    return Gateway.window.performance && window.performance.timing;
  };

  static get shouldBeDelayed() {
    return Gateway.window.performance.timing.loadEventEnd === 0;
  };
}